<template>
  <div class="edo-popup">
    <!-- EDO THANK YOU -->
    <div class="edo-layout" v-if="layout === 'edo'">
      <button class="close-button" data-close aria-label="Close modal" type="button">
        <span aria-hidden="true">&times;</span>
      </button>
      <div class="edo-header-img">
        <img src="https://storage.googleapis.com/wwf-australia-prod.appspot.com/website-public-assets/3505/dist/assets/img/edo-popup-header.jpg">
      </div>
      <div class="edo-content">
        <h3>Thanks for protecting the Unburnt Six!</h3>
        <p>
          Defending these precious habitats is crucial in the fight against
          extinction. Your voice is vital to ensuring they are protected.
        </p>
        <h4>Take the next step with EDO</h4>
        <p>
          Environmental Defenders Office is at the forefront of the legal battle
          to protect our wildlife, climate and communities.
          <span>But winning this fight depends on people like you.</span>
        </p>
        <a :href="edoDonateUrl">Donate to EDO</a>
      </div>

      <button class="edo-close popup-close-button" data-close type="button">
        <span class="popup-close-button-span">Close</span>
      </button>
    </div>

    <!-- WWF THANK YOU -->
    <div v-if="layout === 'wwf'">
      <!-- HEADER -->
      <div class="popup-header">
        <div class="popup-header-logo">
          <img class="popup-logo" src="https://www.wwf.org.au/ecThemes/3/Images/wwf-logo.svg">
        </div>

        <div>
          <button class="popup-close-button" data-close type="button">
            <span class="popup-close-button-span">Close</span>
          </button>
        </div>
      </div>

      <div class="wwf-content">
        <h3>Thank you. Every signature speaks volumes.</h3>
        <div>
          <div class="text-center">
            <img src="/images/UserUploadedImages/403/img-koalas-thumbnail.jpg">
            <br>
            <h4>Want to make a bigger impact?</h4>Australia has the worst mammal extinction rate of any country in the
            world, and with last year’s bushfires having pushed so many more
            species to the brink of extinction, our wildlife urgently needs your
            help, now more than ever.
            <br>
            <br>Your generosity today will help those remaining survive by
            protecting their forest homes.
            <br>Thank you.
            <br>
            <br>
            <a
              href="http://donate.wwf.org.au/donate/one-off-donation/defending-the-unburnt-six"
              class="bttn-mdm-arrw"
            >DONATE TODAY</a>

            <br>
            <br>
            <h4>Take part in the #DefendTheUnburnt video!</h4>Make your voice heard. Help us amplify our collective voice and be
            part of a WWF video to defend the Unburnt Six.
            <a
              href="https://www.wwf.org.au/what-we-do/2-billion-trees/defending-the-unburnt-six/submit-video/submit-video"
            >Click here to upload your video</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { getParameterByName } from "../../helpers";

export default {
  name: "edo-popup",

  data: function() {
    return {
      error: null,
      extensions: [".mp4", ".mkv"],
      fileName: "",
      source: null,
      sourceType: null,
      file: null,
      fileContent: null,
      fileKey: null,
      uploading: false,
      firstName: "",
      lastName: "",
      email: "",
      phoneNumber: "",
      layout: "wwf"
    };
  },

  props: {

    // EDO Content
    edoDonateUrl: {
      type: String,
      default: "https://www.edo.org.au/unburntsix-nextstep"
    },

    // WWF Content
    wwfThankYouTitle: {
      type: String,
      default: "Thanks for protecting the unburnt six!"
    },
    wwfThankYouMessage: {
      type: String,
      default:
        "Defending these precious habitats is crucial in the fight against extinction. Your voice is vital to ensuring they are protected."
    },
    maxFileSize: {
      type: Number,
      default: 15
    }
  },

  computed: {
    isClean() {
      return this.file === null;
    },
    hasError() {
      return this.error != null && this.error.length > 0;
    },
    isUploading() {
      return this.uploading;
    },
    maxSize() {
      return this.maxFileSize * 1000000;
    },
    ...mapState({
      product: state => state.product.product,
      lead: state => state.campaign.edo,
      leadFirstName: state => state.campaign.edo.firstName,
      leadLastName: state => state.campaign.edo.lastName,
      leadEmail: state => state.campaign.edo.email,
      leadPhoneNumber: state => state.campaign.edo.phoneNumber
    })
  },

  watch: {
    leadFirstName(newVal, oldVal) {
      if (newVal && newVal.length > 0) {
        this.firstName = newVal;
      }
    },
    leadLastName(newVal, oldVal) {
      if (newVal && newVal.length > 0) {
        this.lastName = newVal;
      }
    },
    leadEmail(newVal, oldVal) {
      if (newVal && newVal.length > 0) {
        this.email = newVal;
      }
    },
    leadPhoneNumber(newVal, oldVal) {
      if (newVal && newVal.length > 0) {
        this.phoneNumber = newVal;
      }
    }
  },

  created: function() {
    let queryParamLayout = getParameterByName("o");
    if (queryParamLayout === "edo") {
      this.layout = "edo";
    }

    this.firstName = this.leadFirstName;
    this.lastName = this.leadLastName;
    this.email = this.leadEmail;
    this.phoneNumber = this.leadPhoneNumber;
  },

  methods: {
    filesChange(fileList) {
      try {
        if (!fileList.length) return;
        const file = fileList[0];

        if (file.size <= this.maxSize) {
          // Check extension of the file
          const dotIndex = file.name.lastIndexOf(".");

          if (dotIndex < 0) {
            this.error = "File name is missing extension";
            return;
          }

          const extension = file.name.substring(dotIndex).toLowerCase();
          if (!this.extensions.includes(extension)) {
            this.error = `Please use only these formats: ${this.extensions.join(
              ", "
            )}`;
            return;
          }

          this.file = file;
          this.fileName = file.name;
          this.error = null;

          // This key will force Vue.js to update the video component
          // Otherwise, only the source is changed and it doesn't trigger
          // The update of the video component
          this.fileKey = new Date().getTime();

          // Allow to preview
          this.sourceType = file.type;
          this.source = URL.createObjectURL(file);
        } else {
          this.error = "File too big!";
        }
      } catch (err) {
        this.error = "Cannot read the file, please try another one.";
      }
    },
    clearVideo() {
      this.$refs.videoInput.value = "";
      this.fileName = "";
      this.source = null;
      this.sourceType = null;
      this.file = null;
      this.fileKey = null;
    },
    async uploadVideo() {
      try {
        console.log("Upload");
        if (this.file) {
          this.uploading = true;

          // Upload the logo
          const formData = new FormData();
          formData.append("edo-video", this.file, this.fileName);
          const url = await this.$store.dispatch("uploadEDOVideo", formData);

          // Save the meta data to be reviewed
          const meta = {
            campaignId: "edo",
            uploadDate: new Date().toISOString(),
            email: this.email,
            phoneNumber: this.phoneNumber,
            firstName: this.firstName,
            lastName: this.lastName,
            url,
            mimeType: this.sourceType,
            fileName: this.fileName
          };

          await this.$store.dispatch("createFile", meta);

          // Clear the input
          this.clearVideo();
        }
      } catch (err) {
        console.error(err);
      } finally {
        this.uploading = false;
      }
    }
  }
};
</script>

<style scoped>
.edo-layout {
  padding: 30px 15px;
}

#reveal-popup-custom-content .edo-layout .edo-content h3 {
  margin-top: 20px;
}

.edo-layout .edo-content h3::before {
  background-color: #1e9e81;
}

.edo-layout .edo-content h4 {
  margin-top: 20px;
}

.edo-layout .edo-content a {
  display: block;
  width: fit-content;
  margin: auto;
  margin-top: 20px;
  padding: 20px 25px;
  color: white;
  font-size: 20px;
  font-weight: 600;
  background-color: #1e9e81;
  border-radius: 0;
  cursor: pointer;
}

@media screen and (min-width: 1024px) {
  #reveal-popup-custom-content .edo-layout .edo-content h3 {
    margin-top: 20px;
  }
}

/* WWF */
.wwf-content {
  margin-bottom: 20px;
}

#reveal-popup-custom-content .wwf-content h3 {
  text-align: center;
}

#reveal-popup-custom-content .wwf-content h3::before {
  left: 50%;
  transform: translateX(-50%);
}

.file-input-wrapper {
  position: relative;
}

.input-label {
  font-weight: 600;
}

input[type="file"] {
  opacity: 0;
  z-index: 15;
  position: absolute;
  left: 0;
  bottom: 0;
  top: 0;
  margin-bottom: 0;
  cursor: pointer;
}

.file-label {
  margin-top: 8px;
  padding: 12px;
  border: 3px solid var(--wwfOrange);
  border-radius: 8px;
  cursor: pointer;
}

.light .file-label {
  border: 2px solid var(--wwfBlack);
}

.file-label i {
  margin-right: 6px;
}
.preview-container {
  position: relative;
  width: 80%;
  max-height: 300px;
  margin-top: 8px;
  margin-left: auto;
  margin-right: auto;
}

.preview-container .vid-delete {
  z-index: 100;
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 4px;
  right: 4px;
  border-radius: 50%;
  background-color: var(--wwfWhite);
  width: 20px;
  height: 20px;
  font-size: 14px;
  cursor: pointer;
}

.preview-container .vid-delete button {
  padding: 0;
  color: var(--wwfBlack);
  background-color: transparent;
  cursor: pointer;
}

.preview-container .vid-delete i {
  margin: 0;
  cursor: pointer;
}

.preview-container video {
  width: 100%;
  max-height: 100%;
}

.submit-container {
  display: flex;
  justify-content: center;
  width: 100%;
  padding: 16px;
}

.submit-container button {
  padding: 18px;
  color: var(--wwfWhite);
  font-weight: 600;
  background-color: var(--wwfBlue);
  cursor: pointer;
}

.submit-container button:disabled {
  color: var(--wwfGreyA7);
  background-color: var(--wwfGreyDE);
  cursor: default;
}

@media only screen and (max-width: 64.063em) {
  video {
    display: inline-block;
  }
}
</style>


// WEBPACK FOOTER //
// EdoPopup.vue?5d17ea18